/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerRunArtifactStorageLocation } from './DockerRunArtifactStorageLocation';
import { DockerRunArtifactStorageLocationFromJSON, DockerRunArtifactStorageLocationFromJSONTyped, DockerRunArtifactStorageLocationToJSON, } from './DockerRunArtifactStorageLocation';
import type { DockerRunArtifactType } from './DockerRunArtifactType';
import { DockerRunArtifactTypeFromJSON, DockerRunArtifactTypeFromJSONTyped, DockerRunArtifactTypeToJSON, } from './DockerRunArtifactType';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerRunArtifactCreateRequest
 *
 */
// create custom validators for the regexes
export interface DockerRunArtifactCreateRequest {
    /**
     * the fileName of the artifact
     * #type string
     * #memberof DockerRunArtifactCreateRequest
        
        
         */
    fileName: string;
    /**
     *
     * #type DockerRunArtifactType
     * #memberof DockerRunArtifactCreateRequest
        
        
         */
    type: DockerRunArtifactType;
    /**
     *
     * #type DockerRunArtifactStorageLocation
     * #memberof DockerRunArtifactCreateRequest
        
        
         */
    storageLocation?: DockerRunArtifactStorageLocation;
}
/**
 * Check if a given object implements the DockerRunArtifactCreateRequest interface.
 */
export function instanceOfDockerRunArtifactCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerRunArtifactStorageLocationValidator, DockerRunArtifactStorageLocationStringifyShape, DockerRunArtifactStorageLocationStringifyShapeProperties, } from './DockerRunArtifactStorageLocation';
import { DockerRunArtifactTypeValidator, DockerRunArtifactTypeStringifyShape, DockerRunArtifactTypeStringifyShapeProperties, } from './DockerRunArtifactType';
export const DockerRunArtifactCreateRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerRunArtifactCreateRequest => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerRunArtifactCreateRequest => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fileName && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fileName", "type", "storageLocation"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunArtifactCreateRequest => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                    value: input.type
                })) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation || $guard(_exceptionable, {
                    path: _path + ".storageLocation",
                    expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                    value: input.storageLocation
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fileName", "type", "storageLocation"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerRunArtifactCreateRequestTypiaAssertStringify = (input: DockerRunArtifactCreateRequest): string => {
    return ((input: any): string => { const assert = (input: any): DockerRunArtifactCreateRequest => {
        const __is = (input: any): input is DockerRunArtifactCreateRequest => {
            const $io0 = (input: any): boolean => "string" === typeof input.fileName && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunArtifactCreateRequest => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                    value: input.type
                })) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation || $guard(_exceptionable, {
                    path: _path + ".storageLocation",
                    expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                    value: input.storageLocation
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerRunArtifactCreateRequest): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${undefined === input.storageLocation ? "" : `"storageLocation":${undefined !== input.storageLocation ? (() => {
            if ("string" === typeof input.storageLocation)
                return $string(input.storageLocation);
            if ("string" === typeof input.storageLocation)
                return "\"" + input.storageLocation + "\"";
            $throws({
                expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                value: input.storageLocation
            });
        })() : undefined},`}"fileName":${$string(input.fileName)},"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                value: input.type
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerRunArtifactCreateRequestValidatorShape = {
    'fileName': yup.string().defined(),
    'type': DockerRunArtifactTypeValidator.defined(),
    'storageLocation': DockerRunArtifactStorageLocationValidator.optional().default(undefined),
};
export const DockerRunArtifactCreateRequestValidator = yup.object().shape(DockerRunArtifactCreateRequestValidatorShape);
export const DockerRunArtifactCreateRequestStringifyShapeProperties: ObjectSchema['properties'] = {
    'fileName': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'type': DockerRunArtifactTypeStringifyShape,
    'storageLocation': DockerRunArtifactStorageLocationStringifyShape,
};
export const DockerRunArtifactCreateRequestStringifyShape: ObjectSchema = {
    title: 'DockerRunArtifactCreateRequest Stringifier',
    type: 'object',
    properties: {
        ...DockerRunArtifactCreateRequestStringifyShapeProperties
    },
    required: [
        'fileName',
        'type',
    ],
};
export const DockerRunArtifactCreateRequestStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunArtifactCreateRequestStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerRunArtifactCreateRequestStringify: (data: DockerRunArtifactCreateRequest) => string = DockerRunArtifactCreateRequestStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerRunArtifactCreateRequestFromJSON(json: any): DockerRunArtifactCreateRequest {
    return DockerRunArtifactCreateRequestFromJSONTyped(json, false);
}
export function DockerRunArtifactCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunArtifactCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'fileName': json['fileName'],
        'type': DockerRunArtifactTypeFromJSON(json['type']),
        'storageLocation': !exists(json, 'storageLocation') ? undefined : DockerRunArtifactStorageLocationFromJSON(json['storageLocation']),
    };
}
export function DockerRunArtifactCreateRequestToJSON(value?: DockerRunArtifactCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileName': value.fileName,
        'type': DockerRunArtifactTypeToJSON(value.type),
        'storageLocation': DockerRunArtifactStorageLocationToJSON(value.storageLocation),
    };
}
